<nav class="flex bg-white" aria-label="Breadcrumb">
    <ol role="list" class="mx-auto flex w-full space-x-4 pl-4 sm:pl-6 lg:pl-8">
        @for (item of items; track item) {
            <li class="flex">
                <div class="flex items-center">
                    <a [routerLink]="item.href" class="text-sm font-medium text-gray-500 pr-2 hover:text-gray-700">
                        {{ item.name() }}
                    </a>
                    <svg
                        class="h-full w-6 flex-shrink-0 text-gray-200"
                        viewBox="0 0 24 44"
                        preserveAspectRatio="none"
                        fill="currentColor"
                        aria-hidden="true"
                    >
                        <path d="M.293 0l22 22-22 22h1.414l22-22-22-22H.293z" />
                    </svg>
                </div>
            </li>
        }
    </ol>
</nav>
